import { LlmArtifactMenuController, LlmArtifactService, LlmConversationNode } from '@adaptiva/ai/common';
import { AdaLocalizedDatePipe } from '@adaptiva/core/common';
import { ErrorHandlerService } from '@adaptiva/core/error-handler';
import { MathAbsPipe } from '@adaptiva/core/math';
import { MenuTriggerDirectiveModule } from '@adaptiva/core/menus';
import { UiService } from '@adaptiva/core/ui';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { IconComponent } from '@adaptiva/widgets/icon';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { SearchTagComponentModule } from '@adaptiva/widgets/search-tag';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LlmArtifactNamePipe } from './llm-artifact-name.pipe';

@Component({
	selector: '[ada-llm-artifact-list]',
	templateUrl: './llm-artifact-list.component.html',
	styleUrl: './llm-artifact-list.component.scss',
	imports: [
		AdaLocalizedDatePipe,
		AlertComponentModule,
		AsyncPipe,
		IconComponent,
		LlmArtifactNamePipe,
		MathAbsPipe,
		MenuComponentModule,
		MenuTriggerDirectiveModule,
		SearchTagComponentModule,
		TitleCasePipe
	],
	providers: [
		LlmArtifactMenuController,
	]
})
export class LlmArtifactListComponent {

	protected readonly artifacts: LlmArtifactService = inject(LlmArtifactService);

	protected readonly menuController: LlmArtifactMenuController = inject(LlmArtifactMenuController);

	protected readonly errorHandler: ErrorHandlerService = inject(ErrorHandlerService);

	protected readonly ui: UiService = inject(UiService);

	protected onArtifactClicked(_artifact: LlmConversationNode): void {
		try {
			this.artifacts.setActiveArtifact(_artifact);
		} catch (e) {
			this.errorHandler.defaultErrorHandler(e, 'LlmArtifactListComponent.onArtifactClicked');
		}
	}

}
